/**
 * [一般開発者利用不可]
 * 非同期処理のインターフェース
 */
export class AsyncThreadIdVO {
  /** 非同期処理のスレッドID */
  asyncThreadId!: string;
}

export class AsyncStatusVO {
  asyncStatus!: string;
  httpStatus!: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  asyncResponse?: any;
}
